import { Link } from 'react-router-dom';
import { animeList, latestAnimeIds } from '@/mocks/anime';

export default function LatestUpdates() {
  const latestAnimes = latestAnimeIds.map((id) => animeList.find((a) => a.id === id)!).filter(Boolean);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900">最近更新</h2>
            <p className="text-sm text-foreground-500 mt-1">最新上线的动漫剧集</p>
          </div>
        </div>

        <div className="hidden md:block">
          <div className="grid grid-cols-1 gap-0">
            {latestAnimes.map((anime, index) => (
              <Link
                key={anime.id}
                to={`/anime/${anime.id}`}
                className="group flex items-center gap-4 py-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-100/70 px-3 -mx-3 rounded-lg transition-colors cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-400 w-8 text-center">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                  <img src={anime.cover} alt={anime.title} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {anime.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{anime.description}</p>
                </div>
                <div className="flex items-center gap-1 text-accent-500">
                  <span className="text-xs font-medium bg-accent-100 px-2 py-0.5 rounded-full">
                    {anime.category}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                  <span>{anime.episodes}集</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    anime.status === '连载中'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {anime.status}
                  </span>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{anime.updatedAt}</span>
              </Link>
            ))}
          </div>
        </div>

        <div className="md:hidden grid grid-cols-2 gap-4">
          {latestAnimes.map((anime) => (
            <Link
              key={anime.id}
              to={`/anime/${anime.id}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                <img src={anime.cover} alt={anime.title} className="w-full h-full object-cover" />
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 truncate">{anime.title}</h3>
                <div className="flex items-center gap-1 mt-1">
                  <span className="text-xs bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded">{anime.category}</span>
                  <span className="text-xs text-foreground-400">{anime.episodes}集</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}